// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"567dc05a0235f71294c2","293":"413fe36d75d98f0ecc76","518":"1b55f2896a9f286a5ea8","779":"fbbbc96c388a2aae10fa"}[chunkId] + ".js";
};